<script>
export default {
    name: 'oc-row',
    functional: true,
    render: function (h, context) {
        let data = Object.assign({}, context.data, {
            on: context.listeners
        })

        // calculate classes
        if( data.class === undefined ) {
            data.class = {}
        }
        if( ! isArray(data.class) ) {
            data.class = [data.class]
        }

        data.class = Vue.filter('mergeClassExpression')(data.class, ['row'])
        //

        return h(
            'div',
            data,
            context.slots().default
        )
    }
}
</script>
